<template>
  <div class="my-1">
    <label class="lead mb-1">
      Comentario de alarma
    </label>
    <validation-provider
      name="Comentario de alarma"
      rules="required"
      ref="formObserver"
      v-slot="{ errors }"
    >
      <b-form-textarea
        id="alarm_comment"
        rows="3"
        max-rows="6"
        v-model="action.data.alarm_comments"
        :disabled="terminated || validating || action.data.continue"
      ></b-form-textarea>
      <p v-if="errors" class="small text-danger mt-1">
        {{ errors[0] }}
      </p>
    </validation-provider>
    <div class="d-flex flex-column my-2 alarm-comment-buttons">
      <b-button
        variant="primary"
        size="sm"
        :disabled="isSendCommentDisabled"
        @click="onSendCommentClick"
      >
        <feather-icon icon="SendIcon" size="18"/>
        {{ $t("actions.send") }}
      </b-button>
      <b-button
        variant="primary"
        size="sm"
        class="alarm-comment-continue-btn"
        :disabled="isContinueDisabled"
        @click="onContinueClick(action)"
      >
        {{ $t("action_plan.viewer.continue") }}
        <feather-icon icon="ChevronRightIcon" size="18"/>
      </b-button>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import popperHelper from '@/libs/popper-helper'
import {ValidationProvider} from "vee-validate";
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  props: {
    actionPlanLogUuid: String,
    action: Object,
    alarmId: {
      type: [Number, String],
      default: null,
    },
    terminated: Boolean,
    preview: Boolean,
    validating: Boolean,
  },
  components: {
    ValidationProvider,
    vSelect
  },
  data() {
    return {
      withPopper: popperHelper.withPopper,
      formValidated: false,
      sendingComment: false,
    }
  },
  computed: {
    isSendCommentDisabled() {
      if (this.terminated || this.validating || this.action?.data?.continue) {
        return true;
      }
      if (!this.alarmId) {
        return true;
      }
      const comment = this.action?.data?.alarm_comments;
      if (!comment || !String(comment).trim()) {
        return true;
      }
      return this.sendingComment;
    },
    isContinueDisabled() {
      if (this.terminated || this.validating || this.action?.data?.continue) {
        return true;
      }
      return !this.action?.data?.comment_sent;
    },
  },
  mounted() {
    setTimeout(async () => await this.$refs.formObserver.validate(), 50);
  },
  methods: {
    async onContinueClick(action) {
      if (!this.action?.data?.comment_sent) {
        return;
      }
      this.$emit("continue", action);
    },
    async onSendCommentClick() {
      const validation = await this.$refs.formObserver.validate();
      if (!validation.valid) {
        return;
      }
      if (!this.alarmId) {
        return;
      }
      const commentText = this.action?.data?.alarm_comments?.trim();
      if (!commentText) {
        return;
      }
      this.sendingComment = true;
      try {
        const response = await store.dispatch("comments/add", {
          id_alarm: this.alarmId,
          comment: commentText,
        });
        this.$toast({
          component: ToastificationContent,
          props: {
            title: response?.message || this.$t("messages.success.task_completed"),
            icon: "CheckIcon",
            variant: "success",
          },
        });
        this.$set(this.action.data, "comment_sent", true);
        this.$set(this.action.data, "alarm_comments", "");
        await this.$refs.formObserver.validate();
      } catch (error) {
        const message = error?.response?.data?.message || this.$t("errors.generic");
        this.$toast({
          component: ToastificationContent,
          props: {
            title: message,
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.sendingComment = false;
      }
    },
  }
}
</script>

<style scoped>
.alarm-comment-buttons .alarm-comment-continue-btn {
  margin-top: 1.25rem;
}
</style>
